import { gql, useMutation } from "@apollo/client";

const DELETE_COLLECTION_ASSETS = gql`
  mutation DeleteCollectionAssets($input: DeleteCollectionAssetsInput!) {
    deleteCollectionAssets(input: $input)
  }
`;

type AssetsApi = {
  deleteCollectionAssets(
    collectionId: string,
    assetIds: string[]
  ): Promise<void>;
};

export default function useDeleteCollectionAssets(): AssetsApi {
  const [deleteCollectionAssetsMut] = useMutation(DELETE_COLLECTION_ASSETS);

  async function deleteCollectionAssets(
    collectionId: string,
    assetIds: string[]
  ): Promise<void> {
    if (assetIds.length === 0) {
      return Promise.resolve();
    }

    await deleteCollectionAssetsMut({
      variables: {
        input: {
          collectionId,
          assetIds,
        },
      },
    });
  }

  return {
    deleteCollectionAssets,
  };
}
